import * as types from '../mutation-types'

const locale  = '/api/cruds/read?t=Clienti';

// state
export const state = {
  pos: '/api/cruds/read?t=Clienti',
}

// getters
export const getters = {
  pos: state => state.pos,
}

// mutations
export const mutations = {
  [types.SET_POSITION] (state, { locale }) {
    state.pos = locale
  }
}
// actions
export const actions = {
  setPosition ({ commit }, { locale }) {
    commit(types.SET_POSITION, { locale })
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/position.js